// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchBox_search__dcPK7","icon":"SearchBox_icon__JHo9x","input":"SearchBox_input__ZW2_t","disabled":"SearchBox_disabled__44ZdT"};